import { render, staticRenderFns } from "./TheDebtor.vue?vue&type=template&id=032bc9d5&"
import script from "./TheDebtor.vue?vue&type=script&lang=js&"
export * from "./TheDebtor.vue?vue&type=script&lang=js&"
import style0 from "./TheDebtor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports